import { RoundedIconBtn } from '@components/Buttons';
import { mc, StyleProps } from '@styles';
import { TestIdProps } from '@utils';
import React, { FC } from 'react';

type Props = StyleProps & TestIdProps;

const FooterSocials: FC<Props> = ({ style, className, testId }) => {
  return (
    <div data-testid={testId} className={mc('container mx-auto', className)} style={style}>
      <div className="bg-white py-8 flex flex-col lg:flex-row justify-between items-start lg:items-center">
        <div className="relative">
          <div className="text-ocean-blue text-sm font-medium">© {new Date().getFullYear()} CircleOf. All Rights Reserved.</div>
          <div className="absolute -bottom-4.5 text-dark-gray text-sm" data-testid="footer-version">{`v${APP_VERSION}`}</div>
        </div>

        <div className="flex flex-col lg:flex-row items-center lg:mt-0 mt-5">
          <span className="block mr-4 text-ocean-blue text-sm font-medium">Stay in touch. Share the care.</span>

          <div className="flex flex-row items-start lg:items-center mt-2 lg:mt-0 -mx-2">
            <RoundedIconBtn target="_blank" href="https://www.facebook.com/circleofcaregiving" className="mx-2" icon="facebook" />
            <RoundedIconBtn target="_blank" href="https://www.instagram.com/circleof_app/" className="mx-2" icon="instagram" />
            <RoundedIconBtn target="_blank" href="https://twitter.com/circleof_app" className="mx-2" icon="twitter" />
            <RoundedIconBtn target="_blank" href="https://www.linkedin.com/company/circleof" className="mx-2" icon="linkedin" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterSocials;
